<template>
    <v-container class="assignment-view-wrapper">
        <assignment-filters @search="onSearch" @export="onExport"/>
        <!-- <div class="filter-test"><div>{{ this.query }} {{ this.sort }} {{ this.page }}</div></div> -->
        <div class="number-of-results-wrapper">
            <v-btn v-if="isAdminOrCompanyCoordinator" class="mx-2 mt-2 mb-2 white--text" small :color="multipleAssignmentColor" @click="handleMultipleAssignmentClick">
                <v-icon v-if="this.multipleAssignment" medium class="bulding-id-icon">mdi-check</v-icon> Πολλαπλη Αναθεση
            </v-btn>
            <v-dialog v-model="multipleAssignmentDialog" max-width="600">
                <v-card>
                    <v-card-title class="headline">Επιλογή Εργολάβου για Πολλαπλή Ανάθεση</v-card-title>

                    <v-card-text>
                        <v-select
                            v-if="clients.length > 1"
                            v-model="selectedClient"
                            item-text="name"
                            return-object
                            label="Πάροχος"
                            :items="clients"
                            @change="e => onClientSelect(e.id)"
                        ></v-select>
                        <v-select
                            v-model="selectedContractorId"
                            item-text="name"
                            item-value="id"
                            label="Εργολάβος"
                            :items="contractors"
                        ></v-select>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1 white--text" @click="onMultipleCancel">Ακυρωση</v-btn>
                        <v-btn color="black darken-1 white--text" :disabled="!selectedContractorId" @click="assignToContractor">Υποβολη</v-btn>
                    </v-card-actions>
                    <v-card-actions>
                        <alert v-if="showAlert" :show-alert="showAlert" :message="message" :type="type" />
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <div class="number-of-results"><h4 class="mr-1">Σύνολο Αποτελεσμάτων:</h4> {{ this.totalElements }}</div>
        </div>
        <v-container v-if="assignmentViewPreference === 'cards'" class="card-container">
            <v-card
                v-for="assignment of assignments"
                :key="assignment.id"
                class="assignment-card"
                elevation="10"
                max-width="100%"
                link
                @click="assignmentClick(assignment.id)"
            >
                <v-card-title class = "card-title" @click.stop="" :style="assignment.status === 'ASSIGNED' ? `background-color: rgba(${statuses[assignment.status.toLowerCase()].color}, 0.6);` : ''">
                    <div class="sr-type-wrapper">
                        <v-checkbox v-if="multipleAssignment" :input-value="containOnMultiple(assignment.id)" color="green" @click="() => onMultipleAssignmentSelect(assignment.id)"></v-checkbox>
                        <div>{{assignment.sr}}</div>
                        <div class="assignment-type">({{ getTypeText(assignment.type) }})
                            <info-assignment-button :extraInfo="assignment.extraInfo" />
                        </div>
                    </div>
                    <div>
                        <v-chip
                            v-if="assignment.pilotImportType && assignment.type === 'PILOT'"
                            class="mr-2 white--text"
                            :color="assignment.pilotImportType === 'FROM_CONSTRUCTION' ? '#95b8d1' : '#b19cd9'"
                            small
                        >
                            {{ getAssignmentImportTypeText(assignment) }}
                        </v-chip>
                        <assignment-status-label :status="assignment.status" />
                    </div>
                </v-card-title>
                <v-card-subtitle>
                    <assignment-stepper :assignment="assignment" class="assignment-stepper" />
                </v-card-subtitle>
                <v-card-subtitle>
                    <div class="card-subtitle-wrapper">
                        <div class="card-building-wrapper mx-2">
                            <v-icon v-if="assignment.extraInfo?.coordinates" large class="google-maps-icon" @click.stop="openMapOnCoordinates(assignment.extraInfo.coordinates)">mdi-google-maps</v-icon>
                            <v-icon medium class="bulding-id-icon">mdi-domain</v-icon> {{ assignment.buildingId }}
                            <div class="building-info-wrapper">
                                <div v-if="assignment.autopsy?.clientFloor">Όροφος: {{ assignment.autopsy.clientFloor }}</div>
                                <div v-if="assignment.autopsy?.floorStructure">Σύνολο Ορόφων: {{ Object.keys(assignment.autopsy.floorStructure).length || 0 }}</div>
                                <div>Διεύθυνση: {{ assignment.address }}</div>
                                <div>Περιοχή: {{ assignment.location?.name }}</div>
                            </div>
                        </div>
                        <div class="card-client-wrapper mx-2">
                            <v-icon medium class="client-icon">mdi-account</v-icon>Πελάτης
                            <div class="client-info-wrapper">
                                <span>{{ assignment.clientName }}</span>
                            </div>
                        </div>
                        <div class="card-client-wrapper mx-2">
                            <v-icon medium class="client-icon" color="#ffc000">mdi-account-group</v-icon> Ατόμα σε ανάθεση
                            <div class="assignees-info-wrapper">
                                <div>{{ assigneeCount(assignment) }}</div>
                            </div>
                        </div>
                        <div class="card-date-wrapper mx-2">
                            <v-icon medium class="date-icon" >mdi-clock-fast</v-icon>
                            <span v-if="assignment.contractor" class="contractor-assignment">Ανάθεση σε
                                <div v-if="assignment.contractor">
                                    <h4>{{ assignment.contractor.name }}</h4>
                                </div>
                            </span>
                            <span v-else>Δεν έχει ανατεθεί σε εργολάβο</span>
                            <div v-if="assignment.assignedToContractorAt" class="date-info-wrapper">
                                <div>{{ getDate(assignment.assignedToContractorAt) }}</div>
                            </div>
                        </div>
                        <div v-if="assignment.autopsy?.nextStepsAt" class="card-date-wrapper mx-2">
                            <v-icon medium class="date-icon" >mdi-clock-fast</v-icon>
                            <span class="contractor-assignment">Έγκριση Κατασκευής</span>
                            <div class="date-info-wrapper">
                                <div>{{ getDate(assignment.autopsy.nextStepsAt) }}</div>
                            </div>
                        </div>
                        <div class="card-date-wrapper mx-2">
                            <div class="card-date">
                                <v-icon medium class="date-icon" >mdi-sun-clock</v-icon>
                                <div v-if="!assignment.age && assignment.assignedToContractorAt">Ημέρες από ανάθεση: </div>
                                <div v-else-if="assignment.age"> Age: </div>
                                <div v-else> Ημέρες από δημιουργία: </div>
                            </div>
                            <div class="date-info-wrapper">
                                <div v-if="!assignment.age && assignment.assignedToContractorAt"> {{ daysSinceAssignmentCreated(assignment.assignedToContractorAt) }}</div>
                                <div v-else-if="assignment.age"> {{ assignment.age }} </div>
                                <div v-else> {{ daysSinceAssignmentCreated(assignment.createdAt) }} </div>
                            </div>
                        </div>
                    </div>
                </v-card-subtitle>
                <v-card-subtitle>
                    <div class="created-at">
                        Δημιουργήθηκε {{ getDate(assignment.createdAt) }}
                        <span v-if="assignment.contractorFrom?.name"> από <v-chip dark small>{{ assignment.contractorFrom?.name }}</v-chip></span>
                    </div>
                </v-card-subtitle>
            </v-card>
            <v-pagination
                v-if="totalPages"
                class="pagination"
                v-model="page"
                :length="totalPages"
                total-visible="7"
                color="black"
                circle
                @input="paginationChange"
            />
            <div class="pagination-selections">
                <v-select
                    v-model="size"
                    class="size"
                    :hint="`Αντικείμενα / σελίδα: ${this.size}`"
                    :items="sizes"
                    persistent-hint
                    return-object
                    single-line
                    @input="sizeChange"
                />
                <v-autocomplete
                    v-model="page"
                    class="page"
                    :hint="`Μεταφορά στη σελίδα`"
                    :items="Array(totalPages).fill().map((v,i)=> i + 1)"
                    persistent-hint
                    return-object
                    single-line
                    @input="paginationChange"
                />
            </div>
        </v-container>
        <array-view
            v-else
            class="assignment-table"
            :items="assignments"
            :showSelect="multipleAssignment"
            :headers="headers"
            :totalPages="totalPages"
            :page="page"
            :size="size"
            :config="config"
            @paginationChange="tablePaginationChange"
            @item-clicked="(e) => assignmentClick(e.id)"
            @selectRow="onSelect"
        />
    </v-container>
</template>

<script>
    import ArrayView from '@/components/ArrayView.vue'
    import assignmentService from '@/services/assignment'
    import momentTimezone from 'moment-timezone'
    import AssignmentStepper from '@/components/AssignmentStepper.vue'
    import AssignmentStatusLabel from '@/components/AssignmentStatusLabel.vue'
    import client from '@/services/client'
    import AssignmentFilters from '@/components/AssignmentFilters'
    import jwtUtil from '@/utils/jwtUtil'
    import userService from '@/services/user'
    import location from '@/services/location'
    import fileUtil from '@/utils/file'
    import Alert from '@/components/Alert'
    import InfoAssignmentButton from '@/components/InfoAssignmentButton'
    const COMPANY_NAME = process.env.VUE_APP_ENV_COMPANY_NAME
    export default {
        components: { AssignmentFilters, AssignmentStatusLabel, ArrayView, AssignmentStepper, InfoAssignmentButton, Alert },
        computed: {
            isAdminOrCompanyCoordinator() {
                return this.containsAny(['ROLE_ADMIN'], this.userRoles) || (this.containsAny(['ROLE_COORDINATOR'], this.userRoles) && this.userContractor.toLowerCase() === COMPANY_NAME.toLowerCase())
            },
            userRoles() {
                return jwtUtil.getRoles(this.$store.getters.getToken)
            },
            isMyAssignmentsEnabled() {
                return this.$store.getters.getMyAssignmentsEnabled
            },
            userContractor() {
                return this.$store.getters.getUserContractor || ''
            },
            assignmentViewPreference() {
                return this.$store.getters.getAssignmentViewPreference
            },
            currentUserId() {
                return Number(this.$store.getters.getUserId)
            },
            theming() {
                return this.$store.getters.getTheming || {}
            },
            config() {
                return this.$store.getters.getConfig || {}
            },
            types() {
                return this.config?.assignmentTypes || []
            },
            pilotAssignmentImportTypes() {
                return this.config.pilotImportTypes || []
            },
            getPageFromRouteQuery() {
                const routeQuery = this.$route.query
                if (routeQuery && routeQuery.page && !isNaN(routeQuery.page)) {
                    return parseInt(routeQuery.page)
                }
                return 1
            },
            getSizeFromRouteQuery() {
                const routeQuery = this.$route.query
                if (routeQuery && routeQuery.size && !isNaN(routeQuery.size)) {
                    return parseInt(routeQuery.size)
                }
                return 5
            },
            multipleAssignmentColor() {
                if (this.multipleAssignmentIds.length > 0) {
                    return 'green'
                } else if (this.multipleAssignment) {
                    return '#e1c16e'
                } else {
                    return 'black'
                }
            }
        },
        watch: {
            '$route.query': {
                handler(newQuery, oldQuery) {
                    if (newQuery !== oldQuery) {
                        this.getPageAndSizeFromRoute()
                    }
                },
                deep: true
            },
            multipleAssignment: {
                handler(newVal, oldVal) {
                    this.multipleAssignmentIds = []
                }
            }
        },
        data: () => {
            return {
                currentUser: null,
                selectedContractorId: null,
                multipleAssignment: false,
                assignments: [],
                clients: [],
                sizes: [5, 10, 30, 60, 100],
                page: 1,
                size: 5,
                totalPages: 0,
                totalElements: 0,
                panel: undefined,
                query: {},
                sort: null,
                multipleAssignmentDialog: false,
                multipleAssignmentIds: [],
                selectedClient: null,
                contractors: [],
                checkBox: false,
                showAlert: false,
                message: null,
                type: null,
                headers: [
                    {
                        text: 'SR',
                        align: 'start',
                        sortable: false,
                        value: 'sr'
                    },
                    { text: 'Status', align: 'center', value: 'status' },
                    { text: 'Age', value: 'age' },
                    { text: 'Τύπος', value: 'type' },
                    { text: 'Όνομα Πελάτη', align: 'center', value: 'clientName' },
                    { text: 'BuildingId', align: 'center', value: 'buildingId' },
                    { text: 'Διεύθυνση', align: 'center', value: 'address' },
                    { text: 'Περιοχή', align: 'center', value: 'location.name' },
                    { text: 'Α/Κ', align: 'center', value: 'ak' },
                    { text: 'Ανατέθηκε στις', align: 'center', value: 'assignedToContractorAt' },
                    { text: 'Ανατέθηκε σε', align: 'center', value: 'contractor.name' },
                    { text: 'Συμμετέχοντες', align: 'center', value: 'taskAssignments' }
                ],
                statuses: {
                    completed: {
                        text: 'Ολοκληρώθηκε',
                        icon: 'mdi-check',
                        color: '0, 150, 136'
                    },
                    cancelled: {
                        text: 'Ακυρώθηκε',
                        icon: 'mdi-close',
                        color: '204, 85, 0'
                    },
                    assigned: {
                        text: 'Ανατέθηκε',
                        icon: 'mdi-new-box',
                        color: '0, 71, 171'
                    },
                    in_progress: {
                        text: 'Διεκπεραιώνεται',
                        icon: 'mdi-progress-clock',
                        color: '225, 193, 110'
                    }
                }
            }
        },
        async created() {
            this.getPageAndSizeFromRoute()
            this.getAllClients()
            const resp = await userService.getCurrentUser()
            this.currentUser = resp.data
        },
        methods: {
            getAssignmentImportTypeText(assignment) {
                if (assignment.type !== 'PILOT' || !assignment.pilotImportType) {
                    return null
                }
                return this.pilotAssignmentImportTypes.find(type => type.value === assignment.pilotImportType).name
            },
            onSelect(e) {
                this.multipleAssignmentIds = e
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            async assignToContractor() {
                try {
                    await assignmentService.multipleAssignmentToContractor({
                        contractorId: this.selectedContractorId,
                        assignmentIds: this.multipleAssignmentIds
                    })
                    this.onMultipleCancel()
                    this.fetchAllAssignments()
                } catch (e) {
                    if (e.response?.data?.code === 'INTEGRATION_ERROR') {
                        this.setAlert('Η ανάθεση στον εργολάβο ' + e.response.data.message + ' απέτυχε να αποσταλλεί στο σύστημα του. Επικοινωνήστε με τον διαχειριστή', 'error')
                    }
                }
            },
            onMultipleCancel() {
                this.multipleAssignmentDialog = false
                this.multipleAssignmentIds = []
                this.multipleAssignment = false
                this.selectedContractorId = null
            },
            getAllClients() {
                client.getAllClients().then(resp => {
                    this.clients = resp.data
                    if (this.clients.length === 1) {
                        this.selectedClient = this.clients[0]
                        this.onClientSelect(this.selectedClient.id)
                    }
                })
            },
            handleMultipleAssignmentClick() {
                if (this.multipleAssignmentIds.length > 0) {
                    this.multipleAssignmentDialog = true
                } else {
                    this.multipleAssignment = !this.multipleAssignment
                }
            },
            containOnMultiple(assignmentId) {
                const index = this.multipleAssignmentIds.indexOf(assignmentId)
                if (index !== -1) {
                    return true
                }
                return false
            },
            onMultipleAssignmentSelect(assignmentId) {
                const index = this.multipleAssignmentIds.indexOf(assignmentId)
                if (index !== -1) {
                    this.multipleAssignmentIds.splice(index, 1)
                } else {
                    this.multipleAssignmentIds.push(assignmentId)
                }
            },
            getPageAndSizeFromRoute() {
                this.page = this.getPageFromRouteQuery
                this.size = this.getSizeFromRouteQuery
                this.fetchAllAssignments()
            },
            openMapOnCoordinates(coordinates) {
                window.open(`https://www.google.com/maps?q=${coordinates.x},${coordinates.y}`, '_blank')
            },
            getAllLocations() {
                location.getAll().then(resp => {
                    this.locations = resp.data
                })
            },
            getByAddressLike() {
                assignmentService.getAssignmentByAddressLike(this.page, this.size, this.addressLike)
            },
            assigneeCount(assignment) {
                return new Set(assignment.taskAssignments.map(taskAssignment => taskAssignment.assignee.id)).size
            },
            getTypeText(typeValue) {
                return this.types.find(type => type.value === typeValue).name
            },
            daysSinceAssignmentCreated(startDate, endDate) {
                if (endDate) {
                    return momentTimezone(momentTimezone(endDate)).diff(startDate, 'days')
                }
                return momentTimezone(momentTimezone()).diff(startDate, 'days')
            },
            assignmentClick(id) {
                this.$router.push(`/assignments/${id}/edit`)
            },
            onClientSelect(clientId) {
                const selectedClient = this.clients.find(client => client.id === clientId)
                if (selectedClient) {
                    this.contractors = [...selectedClient.contractors.filter(contractor => contractor.assignee === true)]
                }
            },
            sizeChange(size) {
                if (this.getSizeFromRouteQuery !== this.size) {
                    this.$router.push({ query: { page: this.page, size } })
                }
            },
            paginationChange(page) {
                if (this.getPageFromRouteQuery !== this.page) {
                    this.$router.push({ query: { page, size: this.size } })
                }
            },
            tablePaginationChange(page, size) {
                if (page !== this.page || size !== this.size) {
                    this.$router.push({ query: { page, size } })
                }
                this.page = page
                this.size = size
            },
            async fetchAllAssignments() {
                this.query = JSON.parse(localStorage.getItem('assignment-filters')) || {}
                this.sort = JSON.parse(localStorage.getItem('sort')) || ['age', 'DESC']
                delete this.query.taskAssignments
                this.assignments = []
                assignmentService.getAssignments(this.page, this.size, this.query, this.sort).then(resp => {
                    this.assignments = resp.data.content
                    this.totalPages = resp.data.totalPages
                    this.totalElements = resp.data.totalElements
                })
            },
            exportAllAssignments(query, sort) {
                delete query.taskAssignments
                assignmentService.exportAssignments(query, sort).then(resp => this.createExport('assignments', resp.data))
            },
            getDate(date) {
                return momentTimezone(date).tz('Europe/Athens').format('DD/MM/YYYY').toString()
            },
            onSearch(filters, sort) {
                localStorage.setItem('assignment-filters', JSON.stringify(filters))
                localStorage.setItem('sort', JSON.stringify(sort))
                if (this.query.sr) {
                    this.query.sr = this.query.sr.split(',')
                }
                if (this.query.createdAtGte && this.query.createdAtLte) {
                    this.query.createdAtGte = momentTimezone(this.query.createdAtGte).tz('Europe/Athens').startOf('day').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
                    this.query.createdAtLte = momentTimezone(this.query.createdAtLte).tz('Europe/Athens').startOf('day').utc().add(1, 'days').format('YYYY-MM-DD[T]HH:mm:ss[Z]')
                }
                this.fetchAllAssignments()
            },
            onExport(filters, sort) {
                const query = { ...filters }
                if (this.query.assignedToContractorAtGte && this.query.assignedToContractorAtLte) {
                    this.query.assignedToContractorAtGte = momentTimezone(this.query.assignedToContractorAtGte).tz('Europe/Athens').startOf('day').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
                    this.query.assignedToContractorAtLte = momentTimezone(this.query.assignedToContractorAtLte).tz('Europe/Athens').startOf('day').utc().add(1, 'days').format('YYYY-MM-DD[T]HH:mm:ss[Z]')
                }
                this.exportAllAssignments(query, sort)
            },
            createExport(fileName, fileData) {
                const blob = fileUtil.generateXLSXFile(fileData)
                const url = URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.download = `${fileName}.xlsx`

                const container = document.getElementById('app')
                container.appendChild(link)
                link.click()
            },
            containsAny(arr1, arr2) {
                return arr1.some(item => arr2.includes(item))
            }
        }
    }
</script>

<style scoped>
.v-input--selection-controls {
    margin-top: 0 !important;
}
.filter-test {
    display: flex;
    justify-content: center;
}
.assignment-view-wrapper {
    max-width: 90% !important;
}
.v-card__subtitle {
    padding: 0;
}
.card-date {
    display: flex;
}
.page, .size {
    max-width: 150px;
    margin-right: 1rem;
}
.pagination-selections {
    display: flex;
    width: 90%;
    justify-content: flex-end;
}
.create-new {
    display: flex;
    justify-content: end;
}
.card-title {
    display: flex;
    justify-content: space-between;
    background: var(--cards-and-tables-color) !important;
    font-weight: 500;
    font-size: 1.25rem;
    margin-bottom: 1rem;
}

.card-title-2 {
    font-weight: 500;
    font-size: 1.25rem;
}

.v-expansion-panel {
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}

.v-card {
    min-width: 250px;
    position: relative;
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}

.contractor-assignment {
    text-align: center;
}

.assignment-card {
    width: 90%;
    margin-bottom: 0.8rem;
}

.assignment-table {
    max-width: 90% !important;
}

.bulding-id-icon {
    color: #0000A3;
}

.google-maps-icon {
    color: rgb(138, 0, 0);
}

.google-maps-icon:hover {
    color: red;
}

.client-icon {
    color: #009688;
}

.building-info-wrapper {
    display: flex;
    flex-direction: column;
    padding-left: 0.3rem;
}
.card-date-wrapper {
    padding-top: 1rem;
}

.number-of-results-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0 auto;
    width: 87%;
    align-items: center;
    margin-top: 0.5rem;
}

.number-of-results {
    display: flex;
    color: var(--cards-and-tables-text-color) !important;
}

.date-info-wrapper {
    font-size: 0.95rem;
    text-align: center;
    font-weight: 600;
}

.card-subtitle-wrapper {
    padding: 1rem;
    padding-top: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    color: var(--cards-and-tables-text-color);
}

.created-at {
    color: var(--cards-and-tables-text-color) !important;
    width: 100%;
    text-align: center;
    margin-bottom: 0.5rem;
}

.card-building-wrapper {
    max-width: 340px;
    padding-top: 1rem;
}

.card-client-wrapper {
    text-align: center;
    padding-top: 1rem;
}

.date-icon {
    color: gray;
}

.client-info-wrapper {
    font-weight: 600;
    font-size: 1rem;
    max-width: 200px;
}

.assignees-info-wrapper {
    font-weight: 600;
    font-size: 1rem;
}

.card-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 100% !important;
}

.assignment-stepper {
    width: 90%;
    margin: 0 auto;
}

.sr-type-wrapper {
    display: flex;
    flex-wrap: wrap;
}

.assignment-type {
    display: flex;
    font-size: 1rem;
    margin-left: 0.5rem;
}

@media only screen and (max-width: 1000px) {
    .assignment-stepper {
        width: 100%;
        margin: 0 auto;
    }
}

@media only screen and (max-width: 700px) {
    .assignment-view-wrapper {
        max-width: 100% !important;
    }
    .assignment-card {
        width: 100%;
    }
    .expansion-panel {
        max-width: 100%;
    }
}

@media only screen and (max-width: 700px) {
    .assignment-view-wrapper {
        max-width: 100% !important;
    }
    .assignment-card {
        width: 100%;
    }
    .expansion-panel {
        max-width: 100%;
    }
}

@media only screen and (max-width: 400px) {
    .card-subtitle-wrapper {
        flex-direction: column;
        align-items: center;
    }
}
</style>
